import { useState } from "react";

import { sendOtpPatientCreationApi } from "@/utils/apis/doctor/appointment";

import { INotifyEnum, notify } from "@/utils/toaster";

import { useAppDispatch } from "@/store/hooks";
import {
  checkMobileNumber,
  createPatientVerifyOTP,
} from "@/store/slices/doctor/checkMobilePatientExistOrNot";
import { setShowPermission } from "@/store/slices/permission";

import { ILanguageEnums } from "@/models/onboarding";
import { IModalKeyEnums, IUserPermissionEnums } from "@/models/permission";

import { storage } from "@/utils/Storage";
import { usePermissionRestriction } from "@/utils/hooks/usePermissionRestriction";

interface IProps {
  mobileNo: string;
}
const useMobileCheckPatientCreate = (props: IProps) => {
  const [otpId, setOtpId] = useState<string>("");

  const permissionRestrictionHandler = usePermissionRestriction();
  const dispatch = useAppDispatch();

  const checkMobileNumberDetail = (
    mobileNumber: string,
    countryCode: string
  ) => {
    const isPermissionGranted = permissionRestrictionHandler(
      IModalKeyEnums.USER,
      IUserPermissionEnums.CREATE_PATIENT_BY_DOCTOR
    );
    if (!isPermissionGranted) {
      dispatch(setShowPermission(true));
      return;
    }
    dispatch(checkMobileNumber({ mobileNo: mobileNumber, countryCode }));
  };

  const createPatientAfterVerifyOtp = (otp: string) => {
    const language = storage.getSessionToken("lang");
    dispatch(
      createPatientVerifyOTP({
        otp: otp,
        language: language ?? ILanguageEnums.ENG,
        otpId,
      })
    );
  };

  const sendOtpToCreatePatient = async (countryCode: string) => {
    const isPermissionGranted = permissionRestrictionHandler(
      IModalKeyEnums.USER,
      IUserPermissionEnums.OTP_TO_CREATE_PATIENT_BY_DOCTOR
    );
    if (!isPermissionGranted) return;

    const sendOtpPatientCreateResponse = await sendOtpPatientCreationApi({
      countryCode: countryCode,
      phoneNumber: props?.mobileNo,
    });
    if ("result" in sendOtpPatientCreateResponse) {
      setOtpId(sendOtpPatientCreateResponse?.result?.OtpId);
    } else {
      notify(INotifyEnum.ERROR, sendOtpPatientCreateResponse?.message);
    }
  };

  return {
    sendOtpToCreatePatient,
    otpId,
    setOtpId,
    checkMobileNumberDetail,
    createPatientAfterVerifyOtp,
  };
};

export default useMobileCheckPatientCreate;
